import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { OrderedSet as ImmutableOrderedSet, Record as ImmutableRecord } from 'immutable';
import { TRENDING_STATUSES_FETCH_REQUEST, TRENDING_STATUSES_FETCH_SUCCESS } from 'soapbox/actions/trending_statuses';
const ReducerRecord = ImmutableRecord({
  items: ImmutableOrderedSet(),
  isLoading: false
});
const toIds = items => ImmutableOrderedSet(items.map(item => item.id));
const importStatuses = (state, statuses) => {
  return state.withMutations(state => {
    state.set('items', toIds(statuses));
    state.set('isLoading', false);
  });
};
export default function trending_statuses(state = ReducerRecord(), action) {
  switch (action.type) {
    case TRENDING_STATUSES_FETCH_REQUEST:
      return state.set('isLoading', true);
    case TRENDING_STATUSES_FETCH_SUCCESS:
      return importStatuses(state, action.statuses);
    default:
      return state;
  }
}